import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import JoyousForm from './components/JoyousForm';
import Modal from './components/Modal';
import reportWebVitals from './reportWebVitals';

document.addEventListener('DOMContentLoaded', () => {
  const rootDiv = document.getElementById('root');
  const reactRoot = document.getElementById('react-root');
  const openBtn = document.getElementById('open-modal-btn');

  // For the main React app (non-static entry points)
  if (rootDiv) {
    const root = ReactDOM.createRoot(rootDiv);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }

  // For static index.html with JoyousForm on button click
  if (openBtn && reactRoot) {
    openBtn.addEventListener('click', () => {
      reactRoot.style.display = 'block';

      const modalRoot = ReactDOM.createRoot(reactRoot);
      modalRoot.render(
        <React.StrictMode>
          <BrowserRouter>
            <Modal isOpen={true} closeModal={() => reactRoot.style.display = 'none'}>
              <JoyousForm closeModal={() => reactRoot.style.display = 'none'} />
            </Modal>
          </BrowserRouter>
        </React.StrictMode>
      );
    });
  }
});

reportWebVitals();
